import i18next from 'i18next';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';

import { Container, Tooltip, TooltipItem } from './styledComponents';

function CashierStoreTooltip(props) {
  const { cashierStores, translatedStoreName } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  CashierStoreTooltip.handleClickOutside = () => {
    setIsOpen(false);
  };

  return (
    <Container>
      <Button
        buttonCustomStyle={{ padding: 0 }}
        color={'inpulse-outline'}
        handleClick={handleClick}
        icon={'/images/inpulse/list-black-small.svg'}
        iconOnLeft={false}
        label={i18next.t('BACKOFFICE.CASHIER_STORES.SELECTED_CASHIER_STORES_BUTTON', {
          storeName: translatedStoreName,
        })}
        noBorder
      />
      {isOpen && (
        <Tooltip>
          {cashierStores.map((cashierStore) => (
            <TooltipItem key={cashierStore.id}>{cashierStore.name}</TooltipItem>
          ))}
        </Tooltip>
      )}
    </Container>
  );
}

const clickOutsideConfig = {
  handleClickOutside: () => CashierStoreTooltip.handleClickOutside,
};

CashierStoreTooltip.propTypes = {
  cashierStores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    }),
  ),
  translatedStoreName: PropTypes.string,
};

CashierStoreTooltip.defaultProps = {
  cashierStores: [],
  translatedStoreName: '',
};

export default onClickOutside(CashierStoreTooltip, clickOutsideConfig);
